/**
 * INTEG-002 — Qikify/Tepo duplicate Add to Cart suppression
 *
 * Why: Qikify Product Options clones the native ATC button (`button[name="tcustomizer-add"]`)
 * to capture custom-option data. Shopify's Section Rendering API then re-renders the form
 * on every variant change, restoring the native `button[name="add"]` and (in the post-update
 * Qikify build) leaving previous clone(s) behind — producing a stack of ATC buttons.
 *
 * Fix: observe document.body (never replaced) and on every relevant mutation:
 *   1. Within each .product-form__buttons that contains a Qikify clone,
 *      keep only the FIRST clone — drop the rest.
 *   2. Hide every native button[name="add"] in the same wrapper using
 *      style.setProperty('display','none','important') (beats Qikify's inline style.display='block').
 *
 * Original spec: website/theme/INTEG-002-TEPO-DUPLICATE-ATC.md
 */
(function () {
  'use strict';

  var QIKIFY_CLONE_SELECTOR = 'button[name="tcustomizer-add"]';
  var NATIVE_ATC_SELECTOR   = 'button[name="add"]';
  var WRAPPER_SELECTOR      = '.product-form__buttons';
  var HIDDEN_CLASS          = 'tepo-native-btn--hidden';

  function reconcileWrapper(wrapper) {
    if (!wrapper) return;

    // The in-theme picker owns properties and shared upgrades only on opted-in products.
    // Keep the original Qikify path byte-for-byte below for all other products.
    if (wrapper.closest('product-info[data-jl-replace-addon="true"]')) return;

    var clones = wrapper.querySelectorAll(QIKIFY_CLONE_SELECTOR);
    if (clones.length === 0) return;

    for (var i = 1; i < clones.length; i++) {
      clones[i].parentNode && clones[i].parentNode.removeChild(clones[i]);
    }

    var natives = wrapper.querySelectorAll(NATIVE_ATC_SELECTOR);
    for (var j = 0; j < natives.length; j++) {
      var btn = natives[j];
      if (btn.getAttribute('name') === 'tcustomizer-add') continue;
      btn.classList.add(HIDDEN_CLASS);
      btn.style.setProperty('display', 'none', 'important');
      btn.setAttribute('aria-hidden', 'true');
      btn.tabIndex = -1;
    }
  }

  function reconcileAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var wrappers = scope.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i++) reconcileWrapper(wrappers[i]);
  }

  function scheduleReconcile() {
    reconcileAll(document);
    setTimeout(function () { reconcileAll(document); }, 50);
    setTimeout(function () { reconcileAll(document); }, 200);
    setTimeout(function () { reconcileAll(document); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
        reconcileAll(document);
        return;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[data-type="add-to-cart-form"], variant-selects, variant-radios')) {
      scheduleReconcile();
    }
  }, true);

  document.addEventListener('shopify:section:load', scheduleReconcile);
  document.addEventListener('shopify:section:select', scheduleReconcile);
})();
